import { render, staticRenderFns } from "./TermService.vue?vue&type=template&id=6fc5b272&"
import script from "./TermService.vue?vue&type=script&lang=js&"
export * from "./TermService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports